module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "newsletter"
    }
  }, [(_vm.language === "nl" && !_vm.formSubmitted) ? _c('span', {
    staticClass: "bold"
  }, [_vm._v("Blijf op de"), _c('br'), _vm._v("Hoogte")]) : (_vm.language === "en" && !_vm.formSubmitted) ? _c('span', {
    staticClass: "bold"
  }, [_vm._v("Stay up to"), _c('br'), _vm._v("date")]) : _vm._e(), _vm._v(" "), (_vm.language === "nl" && _vm.formSubmitted) ? _c('span', {
    staticClass: "bold"
  }, [_vm._v("U bent geabonneerd op de nieuwsbrief")]) : (_vm.language === "en" && _vm.formSubmitted) ? _c('span', {
    staticClass: "bold"
  }, [_vm._v("Successfully subscribed to Newsletter")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [(_vm.language === "nl" && !_vm.formSubmitted) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }],
    attrs: {
      "type": "text",
      "size": "40",
      "placeholder": "Voornaam"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }) : (_vm.language === "nl" && !_vm.formSubmitted) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }],
    attrs: {
      "type": "text",
      "size": "40",
      "placeholder": "Naam"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && !_vm.formSubmitted) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }],
    attrs: {
      "type": "text",
      "size": "40",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }) : (_vm.language === "en" && !_vm.formSubmitted) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }],
    attrs: {
      "type": "text",
      "size": "40",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "nl" && !_vm.formSubmitted) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Emailadres"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }) : (_vm.language === "en" && !_vm.formSubmitted) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Email adress"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "nl" && !_vm.formSubmitted) ? _c('input', {
    attrs: {
      "type": "submit",
      "value": "verstuur"
    },
    on: {
      "click": _vm.send
    }
  }) : (_vm.language === "en" && !_vm.formSubmitted) ? _c('input', {
    attrs: {
      "type": "submit",
      "value": "send"
    },
    on: {
      "click": _vm.send
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f187300!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dsMailingList.vue
// module id = 210
// module chunks = 2